// extracted by mini-css-extract-plugin
export default {"ring":"loader_ring__5MSXO","spinner":"loader_spinner__SmJaG"};